<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <div class="loader-overlay" *ngIf="isLoading">
    <p-progress-spinner ariaLabel="loading" />
  </div>

  <div class="card bg-white border-round">
    <div class="card-header p-3 ml-auto border-bottom-1 border-gray-200">
      <div class="flex w-full items-center">
        <h2 class="m-0">Rebates List</h2>
      </div>
      <div class="flex justify-content-end gap-2">
        <p-button
          label="Search"
          icon="pi pi-check"
          (click)="submitForm()"
          [loading]="isLoading"
        ></p-button>
        <!-- <p-button
          label="Multi Export"
          icon="pi pi-file"
          styleClass="p-button-info"
          (click)="goToDetailsList()"
        ></p-button> -->
        <p-button
          label="Export"
          icon="pi pi-file-excel"
          styleClass="p-button-help"
          (click)="exportExcel()"
        ></p-button>
      </div>
    </div>
    <div class="card-body p-2">
      <form
        [formGroup]="filterForm"
        novalidate
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="off"
      >
        <div class="grid formgrid p-fluid">
          <!-- contract name -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-file"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="contractName"
                  inputId="contractName"
                  class="w-full"
                  placeholder="Enter Contract Name"
                />
                <label for="contractName">Contract Name</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
          <!-- contract No -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-file"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="contractNo"
                  inputId="contractNo"
                  class="w-full"
                  placeholder="Enter Contract No"
                />
                <label for="contractNo">Contract No</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
          <!-- customer required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-users"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredCustomers"
                  formControlName="customer"
                  inputId="customer"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-customer pTemplate="selectedItem">
                    <div *ngIf="customer">
                      {{ customer.customerNumber }} -
                      {{ customer.customerName }}
                    </div>
                  </ng-template>
                  <ng-template let-customer pTemplate="item">
                    <div>
                      {{ customer.customerNumber }} -
                      {{ customer.customerName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-customer>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #customerInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterCustomers($event)"
                        value="{{ CustomerfilterValue }}"
                      />                   
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="customer">Customer</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['customer'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- business required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredBusinesses"
                  formControlName="business"
                  inputId="business"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"

                >
                  <ng-template let-business pTemplate="selectedItem">
                    <div *ngIf="business">
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template let-business pTemplate="item">
                    <div>
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-business>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #businessInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterBusinesses($event)"
                        value="{{ BusinessfilterValue }}"
                      />
                    
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="business">Business</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['business'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- vendor required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredSuppliers"
                  formControlName="vendor"
                  inputId="vendor"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-vendor pTemplate="selectedItem">
                    <div *ngIf="vendor">
                      {{ vendor.supplierNumber }} -
                      {{ vendor.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template let-vendor pTemplate="item">
                    <div>
                      {{ vendor.supplierNumber }} -
                      {{ vendor.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-vendor>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #vendorInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterSuppliers($event)"
                        value="{{ SupplierfilterValue }}"
                      />
                     
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="vendor">Supplier</label>
              </p-iftalabel>
               <p-inputgroup-addon
                      ><p-button
                        type="button"
                        icon="pi pi-times"
                        (click)="filterForm.controls['vendor'].reset();"
                        styleClass="p-button-secondary addOnBtnClear"
                      ></p-button
                    ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- vendor site -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredSupplierSites"
                  formControlName="vendorSite"
                  inputId="vendorSite"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-vendorSite pTemplate="selectedItem">
                    <div *ngIf="vendorSite">  
                      {{ vendorSite.supplierSiteNumber }} -
                      {{ vendorSite.supplierSiteName }}
                    </div>
                  </ng-template>
                  <ng-template let-vendorSite pTemplate="item">
                    <div>
                      {{ vendorSite.supplierSiteNumber }} -
                      {{ vendorSite.supplierSiteName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-vendorSite> 
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #vendorInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterSupplierSites($event)"
                        value="{{ SupplierSitefilterValue }}"
                      />
                     
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="vendorSite">Supplier Site</label>
              </p-iftalabel>
               <p-inputgroup-addon
                      ><p-button
                        type="button"
                        icon="pi pi-times"
                        (click)="filterForm.controls['vendorSite'].reset();"
                        styleClass="p-button-secondary addOnBtnClear"
                      ></p-button
                    ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- process status  -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="processStatus"
                  formControlName="contractStatus"
                  optionLabel="label"
                  optionValue="value"
                  inputId="contractStatus"
                  class="w-full"
                  placeholder="Select Contract Status"
                ></p-dropdown>
                <label for="status">Contract Status</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
          
          <!--  Type  -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="contractTypes"
                  formControlName="contractType"
                  optionLabel="label"
                  optionValue="value"
                  inputId="contractType"
                  class="w-full"
                  placeholder="Select Contract Type"
                ></p-dropdown>
                <label for="contractType">Contract Type</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <!-- start date required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="startDateActive"
                  [showIcon]="true"
                  inputId="startDateActive"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                ></p-datePicker>
                <label for="startDateActive">Start Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['startDateActive'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- end date requird -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="endDateActive"
                  [showIcon]="true"
                  inputId="endDateActive"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                  [minDate]="filterForm.get('startDateActive')?.value"
                ></p-datePicker>
                <label for="endDateActive">End Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['endDateActive'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

           <!-- Batch number -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-file"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="batchNumber"
                  inputId="batchNumber"
                  class="w-full"
                  placeholder="Enter Batch Number"
                />
                <label for="batchNumber">Batch Number</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mt-2">
    <p-table
      #dt
      [value]="contracts"
      [rows]="25"
      [paginator]="true"
      [paginatorDropdownAppendTo]="'body'"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[25, 50, 100, 500]"
      [totalRecords]="totalRecords"
      (onLazyLoad)="loadContracts($event)"
      [loading]="isLoading"
      [lazy]="true"
      dataKey="id"
      styleClass="p-datatable-striped overflow-x-auto"
    >
      <ng-template pTemplate="caption">
        <div class="flex w-full items-center">
          <h2 class="m-0">Contracts</h2>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 10rem">Actions</th>
          <th pSortableColumn="contractName">
            Contracts Name <p-sortIcon field="contractName"></p-sortIcon>
          </th>
          <th pSortableColumn="contractNumber">
            Contracts Number <p-sortIcon field="contractNumber"></p-sortIcon>
          </th>
          <th>Customer Name</th>
          <th>Customer Number</th>
          <th>Status</th>
          <th>Contract Type</th>
          <th>Batch Number</th>
          <th>Start Date</th>
          <th>End Date</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-contract>
        <tr>
          <td>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-eye"
                styleClass="p-button-rounded p-button-info p-button-outlined"
                (onClick)="ViewContract(contract)"
              ></p-button>
              <!-- <p-button
                icon="pi pi-pencil"
                *ngIf="contract.contractStatus.statusName === 'Draft' || contract.contractStatus.statusName === 'Pending - Sales'"
                styleClass="p-button-rounded p-button-success"
                (onClick)="EditContract(contract)"
              ></p-button> -->
            </div>
          </td>
          <td>{{ contract.contractName }}</td>
          <td>{{ contract.contractNo ?? null }}</td>
          <td>{{ contract.customer.customerName ?? null }}</td>
          <td>{{ contract.customer.customerNumber ?? null }}</td>
          <td>{{ contract.contractStatus.statusName ?? null }}</td>
          <td>{{ contract.contractType ?? null }}</td>
          <td>{{ contract.batchNumber ?? null }}</td>
          <td>{{ contract.startDateActive ?? null }}</td>
          <td>{{ contract.endDateActive ?? null }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No Contracts found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
